import type { QueryParams, SWRConfigInterface } from '@gik/core/api/BaseAPIConfig';
import { wpApi } from '@gik/core/api/ky/wpApi';
import { useWPApi } from '@gik/core/api/swr/useWPApi';
import type WordpressAuthor from '@gik/core/models/wordpress/WordpressAuthor';
import PostsUrlBuilder from '../posts/PostsUrlBuilder';

const path = 'blog-author';

function getParams(slug: string): QueryParams {
  // prettier-ignore
  return new PostsUrlBuilder()
  .withSlug(slug)
    .params as QueryParams;
}

export function getAuthor(slug: string) {
  return wpApi
    .get(path, {
      searchParams: getParams(slug),
    })
    .json<WordpressAuthor[]>();
}

export function useAuthor(slug: string, config?: SWRConfigInterface) {
  // important if there is no slug the path should be null so nothing will be fetched
  return useWPApi<WordpressAuthor[]>(slug ? path : null, getParams(slug), config);
}
